export default __webpack_public_path__ + "27902c20e0994be4c9bbc042490cd36b.png";